import React from "react";
import "./InfoBox.css";

function InfoBox({ title, cases, active, isGreen, total, onClick }) {
  return (
    <div
      onClick={onClick}
      className={`infoBox flex-1 cursor-pointer shadow-lg p-4 ${
        active && "infoBox--selected"
      }`}
    >
      <header className="">
        <div className="infoBox__title">{title}</div>
        <h2 className={`infoBox__cases ${isGreen && "infoBox__cases--green"}`}>
          {cases}
        </h2>
        <div className="infoBox__total">{total} Total</div>
      </header>
    </div>
  );
}

export default InfoBox;
